export default "__VITE_ASSET__11e31b69__$_?component__"